var map = {
	"./GA-01.png": 554,
	"./bg-login.jpg": 5929,
	"./female.jpg": 1159,
	"./forbiddenAccess.png": 8449,
	"./logoNoName.png": 3366,
	"./male.jpg": 3839,
	"./noDataFound1.png": 9698,
	"./noDataFound2.png": 9384,
	"./noimage.png": 8431,
	"./noimage2.png": 1291,
	"./normLogo.png": 4967,
	"./notes.txt": 4972,
	"./pngegg.png": 2177,
	"./whatsapp_icon.png": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4560;